var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hend-picture pt65"},[_c('img',{attrs:{"src":_vm.imgurl,"alt":""}}),_c('div',{staticClass:"toptitle axis-center color-white"},[_c('div',{staticClass:"fs25 pt65 fw600"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }